import { config } from '../config';

export const getTranslations = (fields: string[]) =>
  fetch(
    `${config.apiPublicBaseUrl}/api/v1/translation?fields=${fields.join()}`,
  );
